/**
 * Class for image elements
 */
window.ImageElement = class extends qtee.customDesign.AbstractElement {

	constructor (model, paper, opts) {

		const x = model.get('OriginX');
		const y = model.get('OriginY');
		const scale = model.get('Scale');
		const width = model.get('Width');
		const height = model.get('Height');
		const url = `${model.get('ImageUrl').split('&wid=')[0]}?qlt=75&fmt=jpg&size=${Math.round(
			width * scale
		)},${Math.round(height * scale)}`;
		const element = paper.image(url, x - width / 2, y - height / 2, width, height);

		super(element, opts);

		this.loadFromModel(model);

	}

	ready () {

		return new Promise((resolve, reject) => {

			this.rel.paper.freeTransform(this.rel, this._opts.freeTransform, (ft, events) => {

				if (events.indexOf('scale end') > -1) {

					const s = this.getS();
					const w = Math.round(s * this._origin.width);
					const h = Math.round(s * this._origin.height);
					const oldDimensions = this.rel.node.href.baseVal.split('&size=')[1].split(',');

					if (w > oldDimensions[0] || h > oldDimensions[1]) {

						this.rel.node.href.baseVal = `${this.rel.node.href.baseVal.split('&size=')[0]}&size=${w},${h}`;

					}

				}
				this._opts.callback(ft, events);

			});

			resolve(this.setR(this._origin.rotation).setS(this._origin.scale).apply());

		});

	}

	saveToModel (model) {

		return {
			OriginX: this.getX(),
			OriginY: this.getY(),
			RotationalDegree: this.getR(),
			Scale: this.getS(),
			ZOrder: this.zIndex
		};

	}

	loadFromModel (model) {

		this._origin = Object.freeze({
			rotation: model.get('RotationalDegree'),
			scale: model.get('Scale'),
			width: model.get('Width'),
			height: model.get('Height')
		});

		this._sid = model.id;
		this._cid = model.cid;
		this._type = model.type;
		this.zIndex = model.get('ZOrder');

	}

};
